import { defineStore } from 'pinia';

export const useModal = defineStore('modal', () => {
  const state: Ref<ModalState> = ref({});

  const isOpen = computed(() => !!state.value?.isOpen || false);

  function open(options: ModalOptions): void {
    state.value.component = options.component;
    state.value.props = options.props;
    state.value.listeners = options.listeners;
    state.value.isFullScreen = options.isFullScreen;
    state.value.isOpen = true;
  }

  function close(): void {
    state.value = {};
  }

  return { state, isOpen, open, close };
});

export interface ModalState {
  component?: Component;
  props?: Record<string, any>;
  listeners?: Record<string, (payload?: any) => any>;
  isOpen?: boolean;
  isFullScreen?: boolean;
}

export interface ModalOptions {
  component?: Component;
  props?: Record<string, any>;
  listeners?: Record<string, (payload?: any) => any>;
  isFullScreen?: boolean;
}
